import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormArray, UntypedFormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import {FormlyFormOptions} from '@ngx-formly/core';

@Component({
  selector: 'app-classic-box',
  templateUrl: './classic-box.component.html',
  styleUrls: ['./classic-box.component.scss']
})
export class ClassicBoxComponent implements OnInit, OnChanges {

  @Input() classicBox;
  @Input() data;
  @Output()
  changeForm: EventEmitter<any> = new EventEmitter<any>(true);
  public options: FormlyFormOptions = {};
  public classicForm = new UntypedFormGroup({});

  constructor() {
  }

  ngOnInit() {
    this.classicForm.valueChanges.subscribe(() => {
      this.changeForm.emit(this.classicForm.valid);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onFormSubmit() {
    return this.classicForm.value;
  }

}
